import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import Grid from '@mui/material/Grid';
import { Stack } from '@mui/material';
import Report from './Report';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import WorkflowSubHeader from '../WorkflowSubHeader';

export default () => {
  const { state } = useContext(WorkflowEngineContext);
  const { isReadOnlyView, versionExternalId } = state;

  return (
    <Stack>
      <WorkflowEngineHeader />
      <WorkflowSubHeader />
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Report
            versionExternalId={versionExternalId}
            isReadOnly={isReadOnlyView}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
